<div [ngClass]="statut.statut.code" class="historique-item">
  <div>{{statut.statut.libelle}} {{'label.le' | translate}} {{statut.dateDebut | date:'shortDate'}}</div>

  <div *ngIf="statut.dateReception">{{'page.operateurs.habilitations.historique-item.reception-odg' | translate}}
    {{statut.dateReception |
    date:'shortDate'}}</div>

  <div *ngIf="statut.commentaire">{{statut.commentaire}}</div>
</div>